import z from "zod";
import RemoteCollection from "../utility/remote-collection";

export const EntitlementListItemSchema = z.object({
  id: z.number(),
  productId: z.number(),
  product: z
    .object({
      name: z.string().default("Unknown Product"),
      type: z.string().default("Unknown Product Type"),
    }).prefault({})
});

export const EntitlementDetailItemSchema = EntitlementListItemSchema.extend({
  options: z.unknown().nullish(),
}).loose();

export type EntitlementListItem = z.output<typeof EntitlementListItemSchema>;
export type EntitlementDetailItem = z.output<typeof EntitlementDetailItemSchema>;

export function getEntitlementsByDeploymentCollection(accountId: string, deploymentId: string) {
  return new RemoteCollection(`/api/account/${accountId}/deployment/${deploymentId}/entitlement`, EntitlementListItemSchema, EntitlementDetailItemSchema);
}
